module.exports = __webpack_public_path__ + "media/images/ui__infoBoxSmall-9ca770669c712740ea36d4bc35d206fe.png";